import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import mixpanel from "mixpanel-browser";

// Stripe
import { getCheckoutUrl } from "../../config/stripe-config";

// Redux
import { connect } from 'react-redux';

// Global Functions
import { handleDownload_Windows, handleDownload_Apple } from '../../actions/downloadActions';

// Imgs
import apple_logo from '../common/AppleLogo';
import windows_logo from '../common/Windows';

const DownloadDropdown = ({
    dropdown, 
    setDropdown,
    auth
}) => {

    // Conditionally render scroll to top btn
    useEffect(() => {

        window.addEventListener('scroll', () => {
            setDropdown(false);
        });
    }, []); 

    return (
        <Fragment>
            {/* Dropdown Menu */}
            <div className={dropdown ? "profile-dropdown-topNavbar active" : "profile-dropdown-topNavbar"}>

            <Download_MenuItem platform="apple silicon" auth={auth} />
            <Download_MenuItem platform="apple intel" auth={auth} />

            <div style={{height: '1px', width: '100%', backgroundColor: 'hsla(0,0%,100%,.1)'}} />
            
            <Download_MenuItem platform="windows" auth={auth} />
        </div>

        {/* Hidden Overlay for dropdown */}
        <div 
            className={`hidden-overlay ${dropdown ? "show" : ""}`}
            onClick={() => setDropdown(!dropdown)}
        />
        </Fragment>
    )
}

DownloadDropdown.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(DownloadDropdown);

const Download_MenuItem = ({
    platform,
    auth: {
        isAuthenticated,
        isPremium
    }
}) => {

    const [processing, setProcessing] = useState(false);

    const handleDownload = () => {
        if(!processing) {
            if(platform === 'windows') {
                handleDownload_Windows();
            } else if(platform === 'apple silicon') {
                handleDownload_Apple();
            } else if(platform === 'apple intel') {
                handleDownload_Apple();
            }
        }
    }

    const handleClick = async () => {
        try {
            if(isPremium) {
                setProcessing(true);
                // Download file
                handleDownload();
                setTimeout(() => {
                    setProcessing(false);
                }, 2000);
            } else {
                upgradeToPremium();
            }
        } catch (error) {
            console.log('Something went wrong');
            console.log(error);
        } finally {
            // ---- SEND TO MIXPANEL ----

            if (process.env.NODE_ENV === 'production') {
                if(platform === 'windows') {
                    mixpanel.track("Clicked Download Windows - Dropdown");
                } else if(platform === 'apple silicon') {
                    mixpanel.track("Clicked Download Apple silicon - Dropdown");
                } else if(platform === 'apple intel') {
                    mixpanel.track("Clicked Download Apple intel - Dropdown");
                }
            }

            // ---- END: SEND TO MIXPANEL ----
        }
    }
    
    const upgradeToPremium = async () => {

        if(!isAuthenticated) {
            window.location.href = '/signup';
            return;
        }

        setProcessing(true);

        try {
            let priceId = 'price_1RCl12DsLplMK070ZzZ2pTLg'; // Monthly subscription ID
            const checkoutUrl = await getCheckoutUrl(priceId);
            window.location.href = checkoutUrl;
            console.log('redirected');
        } catch (error) {
            console.log('ERROR GETTING CHECKOUT LINK');
            // console.log(error)
            alert('Something Went Wrong. Please logout and try again.')
        } finally {
            setProcessing(false);
        }
    }

    return (
        <div 
            onClick={() => handleClick()} 
            className="menu-item"
        >
            <div style={{display: 'flex', gap: '.5rem', alignItems: 'center', justifyContent: 'center'}}>
                {platform === "windows" && (
                    <Fragment>
                        <img className='img_filter_white' alt="Windows" loading="lazy" width="20" height="20" decoding="async" src={windows_logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                        {processing ? 'Processing...' : 'Windows'}
                    </Fragment>
                )}

                {(platform === "apple silicon" && platform !== "windows" && platform !== "apple intel") && (
                    <Fragment>
                        <img className='img_filter_white' alt="Apple" loading="lazy" width="20" height="20" decoding="async" src={apple_logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                        {processing ? 'Processing...' : 'macOS (Apple Silicon)'}
                    </Fragment>
                )}

                {(platform === "apple intel" && platform !== "windows" && platform !== "apple silicon") && (
                    <Fragment>
                        <img className='img_filter_white' alt="Apple" loading="lazy" width="20" height="20" decoding="async" src={apple_logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                        {processing ? 'Processing...' : 'macOS (Intel)'}
                    </Fragment>
                )}

            </div>
        </div>
    )
}